export default {
    userId: state => {
        return state.session.userId
    },
    isModeFull: state => {
        return state.mode == 'full';
    },
    allRooms: (state) => {
        return state.groups.groups.concat(state.groups.channels.concat(state.rooms.list));
    }
}